import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from './components/loader/loader.component';
import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'nubo.client';

  // Constructed here rather than left to the top bar: the service also suppresses dark on
  // pre-auth routes, and that has to hold on routes where no top bar is ever rendered.
  private readonly themeService = inject(ThemeService);
}
